import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.194 5.25c-1.555 0-2.633 1.108-2.633 2.464v8.572c0 1.356 1.078 2.464 2.633 2.464h13.534c1.555 0 2.633-1.108 2.633-2.464V7.714c0-1.386-1.11-2.464-2.633-2.464zM1.061 7.714c0-2.243 1.81-3.964 4.133-3.964h13.534c2.265 0 4.133 1.665 4.133 3.964v8.572c0 2.243-1.81 3.964-4.133 3.964H5.194c-2.324 0-4.133-1.72-4.133-3.964z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M12.043 7.071c-5.236 0-8.901 1.586-9.818 3V6.643C2.4 5.914 3.316 4.5 5.498 4.5H18.59c1.09 0 3.273.429 3.273 2.143v3.428c-1.266-1.414-4.582-3-9.818-3Z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.225 6.786v1.167a12 12 0 0 1 1.967-.859c1.8-.612 4.136-1.023 6.851-1.023 3.898 0 6.886.85 8.819 1.969V6.643c0-.322-.165-.58-.654-.81-.508-.24-1.169-.333-1.619-.333H5.499c-1.533 0-2.127.883-2.274 1.286M1.253 6.41C1.52 5.293 2.793 3.5 5.498 3.5H18.59c.64 0 1.617.12 2.472.524.874.412 1.8 1.227 1.8 2.619v6.046l-1.745-1.95c-1-1.12-3.986-2.668-9.072-2.668-2.522 0-4.637.383-6.208.917-1.628.554-2.502 1.211-2.771 1.627l-1.84 2.839v-6.93l.028-.114Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "M11.084 9.771h1.832l2.139 6.643H13.44l-.873-3.343c-.174-.642-.349-1.457-.567-2.142h-.044c-.174.685-.349 1.457-.523 2.142l-.873 3.343H8.989zm-.699 3.858h3.23v1.157h-3.23z" }, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }